import type { Attachment } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { selectedAttachmentsIdsSelector } from '@storeOld/reducers/canvas/selectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import { AttachmentNode } from './components/AttachmentNode'
import css from './TabAttachments.module.scss'

interface Props {
  attachments: Attachment[]
  // the attachments of a page, as opposed to the free ones on the tab
  anchored?: boolean
}

export const AttachmentCollection: React.FC<Props> = ({
  attachments,
  anchored = false,
}) => {
  const selectedAttaches = useSelector(selectedAttachmentsIdsSelector)
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  return (
    <div className={clsJoin(css.container, anchored && css.anchored)}>
      {attachments.map((attachment) => (
        <AttachmentNode
          disabled={!canEdit}
          key={attachment.id}
          attachment={attachment}
          selectedAttaches={selectedAttaches}
        />
      ))}
    </div>
  )
}
